var _effectorFileName = "/builds/gmini/front-ui-kit/src/Backdrop/Backdrop.tsx";
import { useEffect, useState } from 'react';
import { BackdropWrapper } from './Backdrop.styled';
import { jsx as _jsx } from "react/jsx-runtime";
const hideDelay = 195;
export const Backdrop = props => {
  const [isHidden, setIsHidden] = useState(!props.open);
  useEffect(() => {
    if (props.open) {
      setIsHidden(false);
    }

    if (!props.open) {
      setTimeout(() => setIsHidden(true), hideDelay);
    }
  }, [props.open]);
  return /*#__PURE__*/_jsx(BackdropWrapper, {
    style: {
      visibility: isHidden ? 'hidden' : 'initial'
    },
    "aria-hidden": "true",
    ...props,
    children: props.children
  });
};